<template>
	<section class="container"><slot></slot></section>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.container {
	display: flex;
	flex-direction: column;
	gap: 8.8rem;
	max-width: 68rem;
	width: 100%;
	padding: 8.8rem 0rem;
	margin: 0 auto;
	@media screen and (max-width: 1280px) {
		padding: 8rem 0rem 8.8rem;
	}
}
</style>
